module.exports = __webpack_public_path__ + "static/media/fear_free.0e9197eb.jpg";